<template>
  <div v-if="color" :id="elementId" class="customization-swatch__tooltip hidden" qaid="customization-swatch-tooltip">
    <img qaid="customization-swatch-tooltip-thumbnail" :src="imageUrl" alt="" />
    <span
      qaid="customization-swatch-tooltip-name"
      class="p-2 pt-1 pb-1 text-xs font-medium text-left"
      v-html="description"
    />
  </div>
</template>
<script>
import {Cloudinary, CloudinaryConstants} from '@/utils/image/cloudinary-helpers';

export default {
  props: {
    color: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    elementId() {
      return this.color?.id ? `customization-swatch-tooltip-${this.color.id}` : null;
    },
    imageUrl() {
      if (!this.color?.imageThumbnailReference) return '';

      const imageTransformations = {
        w: 225,
        h: 150,
        dpr: `${window.devicePixelRatio}`,
        c: 'fill',
        ...CloudinaryConstants.DEFAULT_PARAMETERS,
      };
      return Cloudinary.createAssetUrl(this.color.imageThumbnailReference, imageTransformations);
    },
    description() {
      return this.color?.description;
    },
  },
};
</script>
<style lang="scss">
.tippy-tooltip.customization-right-rail-swatch-tooltip-theme {
  padding: 0;
  width: 225px;
}
</style>
